import React, { useEffect, useState, useMemo, Fragment } from "react";
import { useDropzone } from "react-dropzone";
import { errorToast} from "../utils/toast"
import { Col } from 'react-bootstrap';


function FileUpload(props) {
    let acceptedTypes = "text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    if (props.excludeExcel !== undefined && props.excludeExcel !== null ){
        acceptedTypes = acceptedTypes.slice(0,9)
    }
    const invalidFileTypeValidation = (file) => {
        let is_ok = false
        acceptedTypes.split(",").map((result_split_string) => {
          result_split_string = result_split_string.replace(" ", "")
          result_split_string = result_split_string.replace("vnd.ms-excel", "rar")
          let all_types = result_split_string.split("/")
          if (all_types.some((type) => file.name.includes(type[1]) || file.name.split(".")[1] === type[1])) {
            is_ok = true
          }
        })
        if (!is_ok) {
          return {
            code: "invalid-file",
            message: `File is not of a valid file`
          };
        }
    }
    const {
        acceptedFiles,
        fileRejections,
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
        inputRef,
      } = useDropzone({ accept: acceptedTypes, maxFiles: 1, validator: invalidFileTypeValidation });
    const baseStyle = {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      alignItems: "center",
      padding: "10px",
      borderWidth: 2,
      borderRadius: 2,
      borderColor: "#eeeeee",
      borderStyle: "dashed",
      backgroundColor: "#fafafa",
      color: "black",
      outline: "none",
      transition: "border .24s ease-in-out",
    };
    const [fileData, setFileData] = useState(null);
  
    const activeStyle = {
      borderColor: "#2196f3",
    };
    
    const acceptStyle = {
      borderColor: "#00e676",
    };
    
    const rejectStyle = {
      borderColor: "#ff1744",
    };
    const style = useMemo(
      () => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
      }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [isDragActive, isDragReject, isDragAccept]
    );
    /* eslint-disable no-unused-vars */
    const removeFile = (file) => () => {
  
      acceptedFiles.splice(acceptedFiles.indexOf(file), 1)
  
    }
  
    const removeAll = () => {
  
      acceptedFiles.length = 0
      acceptedFiles.splice(0, acceptedFiles.length)
      inputRef.current.value = ''
  
    }
    /* eslint-enable no-unused-vars */
  
    useEffect(() => {
      if (acceptedFiles.length > 0) {
        let newAceptedFiles = acceptedFiles
        newAceptedFiles = newAceptedFiles.map((fileUploaded) => {
          if (fileUploaded.name.length > 100) {
            errorToast(
              `Ups error, intente nuevamente el archivo posee un numbre muy largo, fue renombrado!`,
              {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              })
            const data = new File(
              [newAceptedFiles],
              `${"nombre corto"}_${+new Date()}.${fileUploaded.type.split("/")[1]
              }`,
              { type: fileUploaded.type }
            );
            return data
          }
          return fileUploaded
        })
        setFileData(newAceptedFiles);
  
        // here we are going to set the useState in the Table for the callback
        props.filesCallback(newAceptedFiles);
        // }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acceptedFiles]);
  
    useEffect(() => {
      if (fileRejections.length > 0) {
        errorToast(
          `Ups error, intentaste subir más de 1 archivo o un archivo de formato inválido`,
          {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
      }
    }, [fileRejections])
  
    return (
      <Fragment>
        <div className="container fmxw-600">
          <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <p style={{ fontSize: 12 }}>
              {"Arrastrar y soltar aquí"} <br /> o <br />{" "}
              <a href="#">{"Buscar archivos"}</a>
            </p>
            <p style={{ fontSize: 12 }}>{"Tipos de archivos aceptados"}: {acceptedTypes.split(",").map((result_split_string) => {
            result_split_string = result_split_string.replace(" ", "")
            result_split_string = result_split_string.replace("vnd.ms-excel", "xls")
            result_split_string = result_split_string.replace("vnd.openxmlformats-officedocument.spreadsheetml.sheet", "xlsx")
            let all_types = result_split_string.split("/").filter(function (element, index, array) {
              return (index % 2 === 1);
            });
            if (all_types[0] !== undefined && typeof(all_types[0]) !== "undefined" && all_types[0] !== "") {
              return "." + all_types[0]
            }
          }).join(" ")}</p>
          </div>
        </div>
        {fileData ? (
          <div
            className="row"
            style={{
              margin: "10px 0 0 20px",
              fontWeight: "bold",
              color: "black",
            }}
          >
            <p style={{ fontSize: 14 }}>{"Archivos"}: {fileData.map(function (elem) { return elem.name }).join(",")}</p>
          </div>
        ) : (
          ""
        )}
        <div className="row" style={{ margin: "20px", color: "black" }}>
            <Col className="text-center text-md-center">
                    Recuerda subir un archivo con el <br /><b> formato válido</b>
            </Col>
        </div>
      </Fragment>
    );
}

export default FileUpload